import queryString from 'query-string'

const parameterFields = [...document.querySelectorAll('[data-filter]')]
const listElement = document.querySelector('[data-pagelimit]')
const pagelimit = listElement ? listElement.dataset.pagelimit * 1 : 1
const filters = {}

parameterFields.forEach(parameterField => {
    const param = parameterField.getAttribute('data-filter')
    filters[param] = 'all'
})

export default {

    data: {
        filters,
        firstFilter: false,
        listData: window.listData || null,
        filtering: false,
        pagelimit: pagelimit || 100,
        currentlimit: pagelimit,
    },

    computed: {
        filteredData () {
            this.filtering = true

            const filteredList = this.listData.filter(entry => {
                const truthyArray = []

                Object.keys(this.filters).forEach(filter => {
                    let bool = true

                    if (Array.isArray(entry[filter])) {
                        bool = this.filters[filter] === 'all' || entry[filter].includes(this.filters[filter])
                    } else {
                        bool = this.filters[filter] === 'all' || entry[filter] === this.filters[filter]
                    }

                    truthyArray.push(bool)
                })

                return truthyArray.every(bool => bool)
            })

            setTimeout(() => {
                this.filtering = false
            }, 500)

            return filteredList
        },

        paginatedList () {
            return this.filteredData.slice(0, this.currentlimit)
        },

        reachedLimit () {
            return this.paginatedList.length >= this.filteredData.length
        },
    },

    mounted () {
        this.getUrlParams()
    },

    methods: {
        filterList () {
            this.filtering = true
            this.firstFilter = true

            this.updateURLParams()

            this.currentlimit = this.pagelimit

            setTimeout(() => {
                this.filtering = false
            }, 500)
        },

        clearFilters () {
            this.filtering = true
            this.firstFilter = true

            this.currentlimit = this.pagelimit

            Object.keys(this.filters).forEach(filter => {
                this.filters[filter] = 'all'
            })

            this.updateURLParams()

            setTimeout(() => {
                this.filtering = false
            }, 500)
        },

        updateURLParams () {
            const params = {}

            Object.keys(this.filters).forEach(filter => {
                params[filter] = this.filters[filter]
            })

            const newParamString = queryString.stringify(params)
            const newUrl = `${location.origin}${location.pathname}?${newParamString}`

            history.replaceState({}, document.title, newUrl)
        },

        getUrlParams () {
            const params = queryString.parse(location.search)

            Object.keys(params).forEach(key => {
                this.filters[key] = params[key]
            })
        },

        commaSeperatedCategories (categories) {
            const categoriesCapitalized = categories.map(string => string.charAt(0).toUpperCase() + string.slice(1))

            if (categoriesCapitalized.length === 1) {
                return categoriesCapitalized[0]
            } else if (categoriesCapitalized.length === 0) {
                return ''
            }

            const leftSide = categoriesCapitalized.slice(0, categoriesCapitalized.length - 1).join(', ')
            return `${leftSide} and ${categoriesCapitalized[categoriesCapitalized.length - 1]}`
        },

        increaseLimit () {
            const listContainer = document.querySelector('[data-list]')
            const children = [...listContainer.querySelectorAll('[data-id]')]
            const lastChild = children[children.length - 1]
            const lastChildId = lastChild.dataset.id

            if (!this.firstFilter) {
                this.firstFilter = true
            }

            this.currentlimit = this.pagelimit + this.currentlimit

            setTimeout(() => {
                const lastScrollElement = document.querySelector(`[data-id="${lastChildId}"]`)
                const rect = lastScrollElement.getBoundingClientRect()
                const scrollPoint = window.pageYOffset + rect.top + rect.height
                const { nextSibling } = lastScrollElement

                nextSibling.classList.add('-active')

                setTimeout(() => { nextSibling.classList.remove('-active') }, 1000)

                window.scrollTo({
                    top: scrollPoint - 130,
                    left: 0,
                    behavior: 'smooth',
                })
            }, 250)
        },
    },

}
